// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"c004198c","291":"17c7ebc2","894":"e67fb453","921":"6d8f5f87"}[chunkId] + ".chunk.js";
};